import JiraTokenPage from './JiraTokenPage';

export default JiraTokenPage;